"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const silo_hopper_types_1 = require("./silo-hopper.types");
const adjustment_1 = require("services/adjustment");
const contractor_1 = require("services/master-data/contractor");
const driver_1 = require("services/master-data/driver");
const vessel_3 = require("services/master-data/vessel");
const moment_1 = __importDefault(require("moment"));
const silo_1 = require("services/master-data/silo");
const hauler_1 = require("services/master-data/hauler");
const silo_2 = require("services/silo");
const silo_3 = require("services/adjustment/silo");
const brand_1 = require("services/master-data/brand");
const getDataGridSiloHopper = ({ dataStates, start_date, end_date }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getAdjustmentSiloHopper)(dataStates, start_date, end_date);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataSiloTon: response.dataSiloTon,
            dataSiloTrip: response.dataSiloTrip,
            dataGrid: response.isError && response.data.length === 0
                ? []
                : response.data.map(item => {
                    return Object.assign(Object.assign({}, item), { gate_out: (0, moment_1.default)(item.gate_out).format('DD-MM-YYYY HH:mm'), gate_in: (0, moment_1.default)(item.gate_in).format('DD-MM-YYYY HH:mm'), modified_date: new Date(item.modified_date), main_entrance_in: new Date(item.main_entrance_in), time_in: new Date(item.gate_in), time_out: new Date(item.gate_out) });
                })
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DATA_GRID, payload });
    }
});
const getDataGridVesselCorrection = ({ vessel_1_no, start_date, end_date }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, silo_2._getTransactionSiloVessel)({
        start_date: (0, moment_1.default)(start_date).format(),
        end_date: (0, moment_1.default)(end_date).format(),
        vessel_id: vessel_1_no
    });
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataVesselCorrection: response.data.map(i => {
                return Object.assign(Object.assign({}, i), { gate_in_str: (0, moment_1.default)(i.gate_in).format('DD-MM-YYYY HH:mm'), isChecked: false });
            }),
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DATA_GRID_VESSEL, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = {
        dataGrid: [],
        dataStates
    };
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onToggleLoading = (payload) => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_LOADING, payload });
};
const getDataGridDeletedList = ({ dataStates }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, silo_3._getAdjustmentSiloHopperDeleted)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError && response.data.length === 0
                ? []
                : response.data.map(item => {
                    return Object.assign(Object.assign({}, item), { modified_date: new Date(item.modified_date), main_entrance_in: new Date(item.main_entrance_in), gate_in: (0, moment_1.default)(item.gate_in).format('YYYY-MM-DD HH:mm') });
                })
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DATA_GRID_DELETED_LIST, payload });
    }
});
const onFilterChangeDeletedList = payload => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_FILTER_CHANGE_DELETED_LIST, payload });
};
const onSortChangeDeletedList = payload => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_SORT_CHANGE_DELETED_LIST, payload });
};
const onDataStateChangeDeletedList = (dataStatesDeletedList) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield (0, adjustment_1._getAdjustmentSiloHopper)(dataStatesDeletedList);
    const payload = {
        dataGrid: res.isError ? [] : res.data.map(item => {
            return Object.assign(Object.assign({}, item), { modified_date: new Date(item.modified_date), main_entrance_in: new Date(item.main_entrance_in) });
        }),
        dataStates: dataStatesDeletedList
    };
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_PAGE_CHANGE_DELETED_LIST, payload });
});
const onDeleteReason = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._deleteReason)(payload);
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_DELETE_REASON, payload: response });
    }
    else {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage
            }
        });
    }
});
const onDownloadTemplateDocument = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._downloadTemplateSilo)(payload.type);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload });
    }
    else {
        window.open(response.url, '_blank');
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: payload.mutationMode, isLoadingDownload: false }
        });
    }
});
const onUploadSiloManualTicket = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { formdata, filename, type } = payload;
    const responseUpload = yield (0, adjustment_1._uploadSilo)(formdata);
    const responseProcess = yield (0, adjustment_1._uploadSiloManualTicket)({ filename, type });
    if (responseUpload.isError || responseProcess.isError) {
        const payload = {
            isError: true,
            errorCode: responseUpload.errorCode || responseProcess.errorCode,
            errorMessage: responseUpload.errorMessage || responseProcess.errorMessage,
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload });
    }
    else {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isSuccess: true }
        });
    }
});
const onUploadDocumentSilo = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const [survey_doc] = payload.filter(item => item.doctype === 'survey');
    const [approval_doc] = payload.filter(item => item.doctype === 'approval');
    // Upload File Document Survey & Approval
    const response_survey = yield (0, adjustment_1._uploadSilo)(survey_doc.formdata);
    const response_approval = yield (0, adjustment_1._uploadSilo)(approval_doc.formdata);
    if (!response_survey.isError || !response_approval.isError) {
        // Upload Process Document
        const payload = {
            type: 'survey_correction',
            filename: survey_doc.filename,
            justification: survey_doc.justification,
            filename_approval: approval_doc.filename,
        };
        const response_process = yield (0, adjustment_1._uploadSiloManualTicket)(payload);
        if (!response_process.isError) {
            dispatch({
                type: silo_hopper_types_1.adjustmentSiloTypes.ON_MUTATION_CLICK,
                payload: { mutationMode: false, isSuccess: true }
            });
        }
        else {
            dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: response_process });
        }
    }
    else {
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: response_survey || response_approval });
    }
});
const getDataGridHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridUploadHistorySilo)(dataStatesHistory);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            countData: response.countData,
            dataGridHistory: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { uploaded_at: new Date(item.uploaded_at) });
            })
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DATA_GRID_HISTORY, payload });
    }
});
const getLastSucceedUpload = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const newDataStatesHistory = Object.assign(Object.assign({}, dataStatesHistory), { take: 1, sort: [{ field: 'uploaded_at', dir: 'desc' }], filter: {
            logic: 'and',
            filters: [
                { field: 'status', operator: 'contains', value: 'Success' },
            ]
        } });
    const response = yield (0, adjustment_1._getGridUploadHistorySilo)(newDataStatesHistory);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            lastUpdated: response.data.length > 0 ? response.data[0].uploaded_at : null,
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_LAST_SUCCEED_UPLOAD, payload });
    }
});
const onSortChangeHistory = payload => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_SORT_CHANGE_HISTORY, payload });
};
const onFilterChangeHistory = payload => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_FILTER_CHANGE_HISTORY, payload });
};
const onDataStateChangeHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_PAGE_CHANGE_HISTORY, payload: { dataStatesHistory } });
});
const onDateChange = (payload) => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_DATE_CHANGE, payload });
};
const exportDocuments = ({ dataStates, start_date, end_date }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._exportAdjustmentActualHauling)(dataStates, start_date, end_date);
    if (response.isError) {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_EXPORT_DOCUMENTS_URL, payload: response });
    }
});
const clearDocuments = () => dispatch => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.CLEAR_EXPORT_DOCUMENTS_URL, payload: '' });
};
const modifyAdjustmentSilo = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._modifyAdjustmentSilo)(payload);
    if (response.isError) {
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: response });
    }
    else {
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_MODIFY_TICKET_SILO, payload: response });
    }
});
const getDropdownContractor = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'contractor_name', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, contractor_1.getMasterContractor)(dataStates);
    if (response.isError) {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            dropdownContractor: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_CONTRACTOR, payload });
    }
});
const getDropdownBrand = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'name', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, brand_1._getBrandData)(dataStates);
    if (response.isError) {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            dropdownBrand: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_BRAND, payload });
    }
});
const getDropdownDriver = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'driver', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, driver_1._getDriverData)(dataStates);
    if (response.isError) {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            dropdownDriver: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_DRIVER, payload });
    }
});
const getDropdownVessel = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'vessel_no', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, vessel_3._getMasterVessel)(dataStates);
    if (response.isError) {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            dropdownVessel: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_VESSEL, payload });
    }
});
const getDropdownSilo = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'silo', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, silo_1._getSiloData)(dataStates);
    if (response.isError) {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            dropdownSilo: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_SILO, payload });
    }
});
const getDropdownHauler = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'hauler_no', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, hauler_1._getMasterHauler)(dataStates);
    if (response.isError) {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            dropdownHauler: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.SET_DROPDOWN_HAULER, payload });
    }
});
const postDataSilo = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { dataItem, transaction_type } = payload;
    const response = yield (0, silo_2._createTransactionSilo)({
        is_active: true,
        image_penalty_evidence: '',
        brand_id: (_a = dataItem.brand) === null || _a === void 0 ? void 0 : _a.id,
        hauler_id: ((_b = dataItem.hauler) === null || _b === void 0 ? void 0 : _b.id) || '',
        total_capacity: dataItem.total_volume,
        checkpoint_id: ((_c = dataItem.silo) === null || _c === void 0 ? void 0 : _c.id) || '',
        vessel_1_id: ((_d = dataItem.vessel_1) === null || _d === void 0 ? void 0 : _d.id) || '',
        vessel_2_id: ((_e = dataItem.vessel_2) === null || _e === void 0 ? void 0 : _e.id) || '',
        gate_in: (0, moment_1.default)(dataItem.gate_in).format(),
        gate_out: (0, moment_1.default)(dataItem.gate_out).format(),
        contractor_id: ((_f = dataItem.contractor) === null || _f === void 0 ? void 0 : _f.id) || '',
        capacity_volume_1: ((_g = dataItem.vessel_1) === null || _g === void 0 ? void 0 : _g.vessel_capacity) || 0,
        capacity_volume_2: ((_h = dataItem.vessel_2) === null || _h === void 0 ? void 0 : _h.vessel_capacity) || 0,
        main_entrance_in: (0, moment_1.default)(dataItem.main_entrance_in).format(),
        driver_id: ((_j = dataItem === null || dataItem === void 0 ? void 0 : dataItem.driver) === null || _j === void 0 ? void 0 : _j.id) ? dataItem.driver.id : dataItem.driver_id,
        ticket_no: (0, moment_1.default)(dataItem.gate_in).format('YYYYMMDD')
            + (transaction_type === 'ticket adjustment' ? 'D' : 'E') + 'SXXXXX',
        transaction_type: transaction_type == 'ticket adjustment' ? 'manual' : 'survey_correction',
    });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.ON_SAVE_DATAITEM,
            payload: { dataItem, errorCode: 0, errorMessage: '', isError: false },
        });
    }
    else {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR,
            payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }),
        });
    }
});
const postDataCorrection = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { id, id_vessel_new, id_vessel_old } = payload;
    const response = yield (0, silo_3._submitCorrection)({
        id,
        id_vessel_old,
        id_vessel_new
    });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.ON_SAVE_DATAITEM_CORRECTION,
            payload: { errorCode: 0, errorMessage: '', isError: false },
        });
    }
    else {
        dispatch({
            type: silo_hopper_types_1.adjustmentSiloTypes.SET_ERROR,
            payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }),
        });
    }
});
const onCheck = ({ dataVesselCorrection }) => (dispatch) => {
    dispatch({ type: silo_hopper_types_1.adjustmentSiloTypes.ON_CHECK_FILTER, payload: { dataVesselCorrection } });
};
exports.default = {
    onCloseError, onDeleteReason, onClickMutation, onToggleLoading, onDateChange, exportDocuments,
    getDataGridSiloHopper, onSortChange, onFilterChange, onDataStateChange, clearDocuments,
    onUploadDocumentSilo, onUploadSiloManualTicket, onDownloadTemplateDocument, modifyAdjustmentSilo,
    getDataGridDeletedList, onSortChangeDeletedList, onFilterChangeDeletedList, onDataStateChangeDeletedList,
    getDataGridHistory, getLastSucceedUpload, onSortChangeHistory, onFilterChangeHistory, onDataStateChangeHistory,
    getDropdownContractor, getDropdownDriver, getDropdownVessel, getDropdownSilo, getDropdownHauler, postDataSilo,
    getDataGridVesselCorrection, onCheck, postDataCorrection, getDropdownBrand
};
